// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__gK0v4","legacyBtn":"MutateMid_legacyBtn__1To6o"};